import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useLightbox } from "../context/LightboxContext";
import FindMe from "../components/FindMe";
import BackToTop from "../components/BackToTop";
import BrandTitle from "../components/BrandTitle";
import { posts } from "../data/posts";

export default function Home() {
  const showLightbox = useLightbox();

  return (
    <div id="home">
      <Helmet>
        <title>Charlie GP. | Blog</title>
      </Helmet>

      <section className="hero">
        <div className="avatar-wrap">
          <img
            className="hero-avatar"
            src="/images/avatar_rider.jpg"
            alt="Charlie"
            onClick={() => showLightbox("/images/avatar_rider.jpg")}
          />
        </div>
        <h1 className="hero-name">
          CHARLIE GP<span className="dot">.</span>
        </h1>
        <p className="hero-tagline">
          Building with purpose. Architecture, logic, and the pursuit of{" "}
          <Link to="/about/">visual silence</Link>.
        </p>
        <FindMe />
      </section>

      <div className="posts-list">
        {[...posts]
          .sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0))
          .map((post) => (
            <div className="post-item" key={post.path}>
              <Link to={post.path} className="post-title-huge">
                {post.pinned && (
                  <i className="bi bi-bookmark-fill post-pin-icon" aria-hidden="true"></i>
                )}
                <BrandTitle text={post.title} />
                <span className="dot">.</span>
              </Link>
              <span className="post-meta-caps">
                {post.date}{post.readTime ? ` • ${post.readTime.toUpperCase()}` : ""}
              </span>
              <p className="post-excerpt">{post.excerpt}</p>
              <Link to={post.path} className="read-more-link">Read More</Link>
            </div>
          ))}
      </div>

      <BackToTop />
    </div>
  );
}